import React, { Component } from "react";
import "./Contact.css";
import emailjs from "emailjs-com";
import LightSpeed from "react-reveal/LightSpeed";
import Fade from "react-reveal/Fade";
import ReCAPTCHA from "react-google-recaptcha";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

import possibiWhoarewe from "./assets/1259.png";

const getBusinessStatus = () => {
  const now = new Date();
  const day = now.getDay();
  const current = now.getHours() * 60 + now.getMinutes();

  const openTime = 9 * 60 + 30;
  const closeTime = 19 * 60;

  if (day >= 0 && day <= 4 && current >= openTime && current < closeTime) {
    const remaining = closeTime - current;
    const hours = Math.floor(remaining / 60);
    const minutes = remaining % 60;

    return {
      open: true,
      text: `פתוח עכשיו · נסגר בעוד ${hours} שעות ו-${minutes} דקות`,
    };
  }

  let daysUntilOpen = 0;

  if (day >= 0 && day <= 4) {
    if (current < openTime) {
      daysUntilOpen = 0;
    } else {
      daysUntilOpen = 1;
    }
  } else if (day === 5) {
    daysUntilOpen = 2;
  } else {
    daysUntilOpen = 1;
  }

  const nextOpening = new Date(now);
  nextOpening.setDate(now.getDate() + daysUntilOpen);
  nextOpening.setHours(9, 30, 0, 0);

  const remaining = Math.max(0, Math.floor((nextOpening - now) / 60000));
  const hours = Math.floor(remaining / 60);
  const minutes = remaining % 60;

  return {
    open: false,
    text:
      daysUntilOpen === 0
        ? `סגור · נפתח היום בשעה 09:30`
        : daysUntilOpen === 1
        ? `סגור · נפתח מחר בשעה 09:30`
        : `סגור · נפתח ביום ראשון בשעה 09:30`,
  };
};

class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captchaToken: null,
      loading: false,
      businessStatus: getBusinessStatus(),
    };

    this.isSending = false;
    this.captchaRef = React.createRef();
    this.statusInterval = null;
  }

  componentDidMount() {
    this.statusInterval = setInterval(() => {
      this.setState({
        businessStatus: getBusinessStatus(),
      });
    }, 60000);
  }

  componentWillUnmount() {
    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }
  }

  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };

  handleCaptchaExpired = () => {
    this.setState({
      captchaToken: null,
    });
  };

  sendEmail = (e) => {
    e.preventDefault();

    if (this.isSending) return;

    if (!this.state.captchaToken) {
      alert("יש לאשר שאינך רובוט");
      return;
    }

    this.isSending = true;

    const form = e.currentTarget;

    this.setState({
      loading: true,
    });

    emailjs
      .sendForm(
        "service_b9gmcqa",
        "template_hv6pk2g",
        form,
        "JWHOQYzsIcnM9KDko"
      )
      .then(() => {
        alert("ההודעה נשלחה בהצלחה! ניצור איתך קשר בהקדם.");

        form.reset();

        if (this.captchaRef.current) {
          this.captchaRef.current.reset();
        }

        this.setState({
          loading: false,
          captchaToken: null,
        });

        this.isSending = false;
      })
      .catch(() => {
        alert("אירעה שגיאה בשליחת ההודעה. נסה שנית.");

        if (this.captchaRef.current) {
          this.captchaRef.current.reset();
        }

        this.setState({
          loading: false,
          captchaToken: null,
        });

        this.isSending = false;
      });
  };

  render() {
    const { businessStatus, loading, captchaToken } = this.state;

    return (
      <section className="contact-page" dir="rtl">

        <div className="contact-background-glow contact-glow-one" />
        <div className="contact-background-glow contact-glow-two" />

        <div className="contact-container">

          <Fade top>
            <header className="contact-header">


              <span className="contact-eyebrow">
                אנחנו כאן בשביל העסק שלך
              </span>

              <h1>
                בואו נדבר על
                <span> העסק שלכם</span>
              </h1>

              <p>
                יש לכם רעיון לאתר חדש? רוצים לשדרג את הנוכחות הדיגיטלית
                שלכם? השאירו פרטים ונחזור אליכם עם פתרון מקצועי.
              </p>

              <div className="contact-header-line" />

            </header>
          </Fade>

          <LightSpeed right>
            <div className="contact-form-section">

              <div className="contact-form-info">

             

                <h2>
                  הצעד הבא של העסק
                  <span> מתחיל כאן</span>
                </h2>

                <p>
                  אנחנו מאמינים שכל עסק צריך אתר מקצועי שמייצר אמון,
                  מציג את השירותים בצורה נכונה ועוזר להפוך מבקרים ללקוחות.
                </p>

                <div className="contact-benefit">
                  <span className="contact-check">✓</span>
                  <span>יחס אישי וליווי מקצועי</span>
                </div>

                <div className="contact-benefit">
                  <span className="contact-check">✓</span>
                  <span>התאמה מלאה לצרכים של העסק</span>
                </div>

                <div className="contact-benefit">
                  <span className="contact-check">✓</span>
                  <span>אתרים מותאמים למחשב ולנייד</span>
                </div>

  
              </div>

              <form
                className="contact-form"
                onSubmit={this.sendEmail}
                noValidate={false}
              >

                <div className="contact-form-heading">
                  <span>השאירו פרטים</span>
                  <h2>ונחזור אליכם בהקדם</h2>
                  <p>מלאו את הפרטים ונשמח לעזור לכם.</p>
                </div>

                <div className="contact-field">

                  <label htmlFor="contact-name">
                    שם מלא <span>*</span>
                  </label>

                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    placeholder="איך קוראים לך?"
                    autoComplete="name"
                    required
                  />

                </div>

                <div className="contact-field">

                  <label htmlFor="contact-phone">
                    מספר טלפון <span>*</span>
                  </label>

                  <input
                    id="contact-phone"
                    type="tel"
                    name="tel"
                    placeholder="הזינו מספר טלפון"
                    autoComplete="tel"
                    inputMode="tel"
                    required
                  />

                </div>

                <div className="contact-field">

                  <label htmlFor="contact-message">
                    במה נוכל לעזור? <span>*</span>
                  </label>

                  <textarea
                    id="contact-message"
                    name="message"
                    placeholder="ספרו לנו קצת על הפרויקט שלכם..."
                    rows="5"
                    required
                  />

                </div>

                <div className="contact-captcha">

                  <ReCAPTCHA
                    ref={this.captchaRef}
                    sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
                    onChange={this.handleCaptchaChange}
                    onExpired={this.handleCaptchaExpired}
                  />

                </div>

                <button
                  className={`contact-submit ${loading ? "is-loading" : ""}`}
                  type="submit"
                  disabled={loading || !captchaToken}
                >

                  {loading ? (
                    <>
                      <span className="contact-spinner" />
                      שולח את ההודעה...
                    </>
                  ) : (
                    <>
                      שליחת הודעה
                      <span className="contact-submit-arrow">←</span>
                    </>
                  )}

                </button>

                <div className="contact-privacy-note">
                  הפרטים שלכם ישמשו לצורך יצירת קשר בלבד.
                </div>

              </form>

            </div>
          </LightSpeed>

          <Fade bottom>
            <div className="contact-details-heading">
              <h2>כל הדרכים ליצור איתנו קשר</h2>
              <p>
                נשמח לעמוד לשירותכם ולענות על כל שאלה.
              </p>
            </div>
          </Fade>

          <div className="contact-cards">

            <Fade bottom>
              <article className="contact-card">

                <div className="contact-card-icon">☎</div>

                <span className="contact-card-label">
                  דברו איתנו
                </span>

                <h3>טלפון</h3>

                <p>050-6831839</p>

                <a
                  className="contact-card-button"
                  href="tel:0506831839"
                >
                  התקשר עכשיו
                  <span>←</span>
                </a>

              </article>
            </Fade>

            <Fade bottom>
              <article className="contact-card">

                <div className="contact-card-icon">✉</div>

                <span className="contact-card-label">
                  אנחנו במייל
                </span>

                <h3>דואר אלקטרוני</h3>

                <p className="contact-email">
siteb2b2@gmail.com
                </p>

                <a
                  className="contact-card-button"
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=siteb2b2@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  שליחת מייל
                  <span>←</span>
                </a>

              </article>
            </Fade>

            <Fade bottom>
              <article className="contact-card">

                <div className="contact-card-icon">⌖</div>

                <span className="contact-card-label">
                  המיקום שלנו
                </span>

                <h3>המשרד שלנו</h3>

                <p>
                  רחוב שוהם 5
                  <br />
                  רמת גן
                </p>

                <a
                  className="contact-card-button"
                  href="https://waze.com/ul?q=רחוב%20שוהם%205,%20רמת%20גן&navigate=yes"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ניווט ב-Waze
                  <span>←</span>
                </a>

              </article>
            </Fade>

            <Fade bottom>
              <article className="contact-card">

                <div className="contact-card-icon">◷</div>

                <span className="contact-card-label">
                  זמינים עבורכם
                </span>

                <h3>שעות פעילות</h3>

                <p>
                  ראשון - חמישי
                  <br />
                  09:30 - 19:00
                </p>

                <div className="contact-status-wrapper">

                  <div
                    className={`contact-status ${
                      businessStatus.open ? "status-open" : "status-closed"
                    }`}
                  >
                    <span className="contact-status-dot" />
                    {businessStatus.open ? "פתוח עכשיו" : "סגור כרגע"}
                  </div>

                </div>

              </article>
            </Fade>

          </div>

          <Fade bottom>
            <div className="contact-map-heading">
              <h2>מוזמנים להגיע אלינו</h2>
              <p>שוהם 5, רמת גן</p>
            </div>

            <div className="contact-map-container">

              <Map
                google={this.props.google}
                zoom={15}
                fullscreenControl={true}
                zoomControl={true}
                streetViewControl={true}
                mapTypeControl={false}
                initialCenter={{
                  lat: 32.084890,
                  lng: 34.800629,
                }}
                style={{
                  width: "100%",
                  height: "100%",
                }}
                containerStyle={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                }}
              >

                <Marker
                  position={{
                    lat: 32.084890,
                    lng: 34.800629,
                  }}
                  title="רחוב שוהם 5, רמת גן"
                />

              </Map>

            </div>
          </Fade>

          <div className="contact-bottom-message">
            <h2>
               העסק שלכם ראוי לאתר
              <span> ברמה אחרת.</span>
            </h2>

            <p>
              SITE B2B – בניית אתרים לעסקים שמביאים לקוחות.
            </p>

        
          </div>

        </div>

      </section>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyC2H55uGYHc55B2L3CwQd2Jzijoj_isaU0",
  language: "he",
  region: "IL",
})(Contact);
